import { createFileRoute } from '@tanstack/react-router'
import { AboutPage } from '../components/pages/AboutPage'
import { publicPageHead } from '../lib/seo'

export const Route = createFileRoute('/about')({
  component: AboutPage,
  head: () => publicPageHead({
    title: 'About Lyle Patterson | Autoglow Detailing',
    description:
      'Meet Lyle Patterson, GYEON certified detailer at Autoglow in Drysdale — ceramic coating and paint correction for the Bellarine Peninsula and Greater Geelong.',
    path: '/about',
    ogDescription: 'About Lyle Patterson and the Autoglow Detailing studio in Drysdale.',
  }),
})
